import { EntityTypeSupportingPinnedFields } from "@mapmycustomers/shared/types/entity";

import { SourceObjectEntityType } from "./constants";

// Identifies one pinned list: the shared list of a record type, or the list of one of its subtypes
export type ListRef =
  | { entityType: EntityTypeSupportingPinnedFields; kind: "shared" }
  | { entityType: SourceObjectEntityType; key: string; kind: "subtype" };

export const toPersistedKey = (ref: ListRef): string =>
  ref.kind === "shared" ? ref.entityType : ref.key;

export const isSameListRef = (first: ListRef, second: ListRef): boolean =>
  first.kind === second.kind &&
  first.entityType === second.entityType &&
  toPersistedKey(first) === toPersistedKey(second);
